import { apiFetch } from './client';
import type { CreateMaterialInput, CreateUnitInput } from '@shared/schemas';

export type CatalogMaterial = {
  id: string;
  scope: 'global' | 'business';
  name: string;
  defaultUnitId: string;
  defaultGstBasisPoints: number;
  defaultRatePaise: number | null;
};

export type CatalogUnit = {
  id: string;
  scope: 'global' | 'business';
  name: string;
  category: 'weight' | 'purity' | 'count';
};

export function fetchMaterials(): Promise<{ materials: CatalogMaterial[] }> {
  return apiFetch('/api/catalog/materials');
}

export function fetchUnits(): Promise<{ units: CatalogUnit[] }> {
  return apiFetch('/api/catalog/units');
}

export function createMaterial(input: CreateMaterialInput): Promise<{ material: CatalogMaterial }> {
  return apiFetch('/api/catalog/materials', { method: 'POST', json: input });
}

export function createUnit(input: CreateUnitInput): Promise<{ unit: CatalogUnit }> {
  return apiFetch('/api/catalog/units', { method: 'POST', json: input });
}

export function deleteMaterial(id: string): Promise<{ ok: true }> {
  return apiFetch(`/api/catalog/materials/${encodeURIComponent(id)}`, { method: 'DELETE' });
}

export function deleteUnit(id: string): Promise<{ ok: true }> {
  return apiFetch(`/api/catalog/units/${encodeURIComponent(id)}`, { method: 'DELETE' });
}
